/**
 * Kabuk ayarları (M6 WP 6.2): menüde görünen bölümler, menü grup sırası ve arayüz dili. Kaynak `GET /me/shell` (çağıranın
 * rolü ∩ departman görünürlüğü ∩ çalışma alanı menü ayarı).
 *
 * MENÜ GÖRÜNÜRLÜĞÜ YETKİ DEĞİLDİR: gizlenen bölümün menü öğesi çizilmez, ama kayıt erişimi sunucuda rol/yetenek/paylaşım ile
 * belirlenir ve değişmez (doğrudan bağlantı ve arama çalışmaya devam eder). Yanıt gelene kadar ya da alınamazsa menü yalnız
 * yetenek süzgeciyle çizilir (hiçbir öğe ayar yüzünden erişilmez kalmaz).
 */
import { useQuery } from '@tanstack/react-query';
import type { Section, ShellSettings } from '@castinflow/shared';
import { apiFetch } from '../lib/api';
import { useScope, type Scope } from '../lib/scope';

export const shellKeys = {
  shell: (s: Scope) => ['t', s.tenantId, 'u', s.userId, 'shell'] as const,
};

export function useShellSettings() {
  const scope = useScope();
  return useQuery({
    queryKey: scope ? shellKeys.shell(scope) : ['shell', 'none'],
    queryFn: () => apiFetch<ShellSettings>('/me/shell'),
    enabled: scope !== null,
    staleTime: 60_000,
    // Yönetici menüyü ya da dili değiştirdiğinde sekmeye dönen kullanıcı güncel ayarı görsün
    refetchOnWindowFocus: true,
  });
}

/** Menü öğesi → bölüm. Eşlemesi olmayan öğe (genel bakış, onaylar, yönetim araçları) bölüm ayarından etkilenmez. */
export const NAV_ITEM_SECTION: Readonly<Record<string, Section>> = {
  feed: 'newsfeed',
  leads: 'leads',
  'lead-overview': 'leads',
  'lead-sequences': 'leads',
  'lead-center': 'leads',
  'lead-distribution': 'leads',
  'campaign-report': 'leads',
  'marketing-workcenter': 'leads',
  'marketing-segments': 'leads',
  'marketing-rewin': 'leads',
  'marketing-quality': 'leads',
  opportunities: 'opportunities',
  'opportunity-board': 'opportunities',
  proposals: 'proposals',
  orders: 'orders',
  'order-board': 'orders',
  contracts: 'contracts',
  'purchase-orders': 'purchase_orders',
  activities: 'activities',
  'activity-board': 'activities',
  'activity-map': 'activities',
  'activity-calendar': 'calendar',
  dashboard: 'dashboard',
  'activity-report': 'dashboard',
  goals: 'goals',
  tickets: 'tickets',
  'support-overview': 'tickets',
  forms: 'forms',
  'form-documents': 'forms',
  companies: 'companies',
  contacts: 'contacts',
  products: 'products',
};
